const template = {
	template: 'designer',
	name: '',
	titleName: '',
	displayName: '',
	shopLink: '',
	logoImg: '',
	description: [
		'',
		'',
		'',
	],
};

const ajaffe = {
	template: 'designer',
	name: 'A.JAFFE',
	titleName: 'A. Jaffe Designer',
	displayName: 'A.JAFFE',
	// shopLink: 'gallery/engagement-rings?mode=setting&designer=ajaffe',
	links: [
		{name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designer=ajaffe'},
		{name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=ajaffe'},
		// {name: "Men's Bands", url: 'gallery/wedding-bands/mens?designers=ajaffe'},
	],
	description: [
		'Passion and devotion are the cornerstones to any good relationship. They are also the signature qualities of A.JAFFE engagement bands and wedding rings. For over 100 years, A. JAFFE has been steadfast in the commitment to honor love in a way that is as lasting as it is beautiful. All bands are painstakingly forged from platinum or gold that is nickel free and ensconced in palladium to ensure that like your love, our rings are strong and will never fade, dull or fracture. A.JAFFE celebrates the rare beauty of your relationship with handpicked diamonds selected by experienced master jewelers guaranteeing utmost comfort. Individually hewn prongs, ergonomic squared shank and secure setting, in addition to six polishing stages, safe-guard against potential spinning and snags on clothing.',
		'Make a one of a kind ring for your loved one. Make a ring as unique as your story. A.JAFFE doesn’t just welcome customization, we encourage it. Choose from a variety of precious metals and diamonds that capture not only who you are as a couple, but also the uniqueness of the love you possess. Commemorate the unforgettable moment your beloved caught your eye with an eye catching engagement ring or wedding band customized by an A. JAFFE master craftsman. A.Jaffe creates more than just rings. A.Jaffe upholds tradition. Let us be a part of yours.',
	],
};

const artcarved = {
	template: 'designer',
	name: 'Art Carved',
	titleName: 'ArtCarved Designer',
	displayName: 'Art Carved',
	// shopLink: 'gallery/engagement-rings?mode=setting&designer=artcarved',
	links: [
		{name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designers=artcarved'},
		{name: "Men's Bands", url: 'gallery/wedding-bands/mens?designers=artcarved'},
		{name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=artcarved'},
		// {name: "Fashion", url: 'gallery/fine-jewelry?designer=artcarved'},
	],
	description: [
		'ArtCarved beams with pride for having the ability to handcraft the highest quality, graceful and timeless engagement rings and wedding bands. ArtCarved believes in finding the one. Like your love story, ArtCarved rings are one-of-a-kind. Exquisitely crafted and thoughtfully designed, ArtCarved is the ultimate expression of devotion that sparkles with joy. Made with happiness, passion and love since 1850.',
	],
};

const cgonshor = {
	template: 'designer',
	name: 'C. Gonshor',
	titleName: 'C. Gonshor',
	displayName: 'C. Gonshor',
	// shopLink: 'gallery/engagement-rings?mode=setting&designer=cgonshor',
	links: [
		{name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designers=cgonshor'},
		{name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=cgonshor'},
	],
	logoImg: 'gonshor.svg',
	description: [
		'C. Gonshor has become synonymous with highly evolved style and quality. While there are many avenues to choose from, what sets C. Gonshor apart and what will ultimately affects our relationship, is the finished piece you receive from us.',
		'Every C. Gonshor engagement ring and wedding band is created by highly skilled craftsmen who are proud of and accomplished by their work.',
	],
};

const christianbauer = {
	template: 'designer',
	name: 'Christian Bauer',
	titleName: 'Christian Bauer',
	displayName: 'Christian Bauer',
	shopLink: 'gallery/wedding-bands/mens?designers=christianbauer',
	logoImg: 'bauer.svg',
	description: [
		'Christian Bauer is a German company specializing in the construction of wedding rings. The brand offers an attractive wedding band collection made of high quality resources like gold and platinum, as well as handpicked diamonds and gems. Every Christian Bauer wedding ring is unique and crafted with high precision and innovation.',
	],
};

const christopherdesigns = {
	template: 'designer',
	name: 'Christopher Designs',
	titleName: 'Christopher Designs',
	displayName: 'Christopher Designs',
	// shopLink: 'gallery/engagement-rings?mode=setting&designer=christopherdesigns',
	logoImg: 'christopher.svg',
	description: [
		'Christopher Slowinski founded Christopher Designs in 1981 after he apprenticed under master jewelry craftsmen in his native country of Poland and once he moved to the United States.',
		'Today, he combines his classic training with modern technology to create exclusive engagement ring and wedding band designs that include his patented Crisscut® diamonds. The original Crisscut® was launched with great fanfare: the arrangement of the 77 “crisscrossed” facets redefined just how brilliant a diamond could be. Choosing a Christopher Designs engagement ring or wedding band truly brings your love to life.',
	],
};

const coast = {
	template: 'designer',
	name: 'Coast',
	titleName: 'Coast Designer',
	displayName: 'Coast',
	// shopLink: 'gallery/engagement-rings?mode=setting&designer=coast',
	links: [
		{name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designer=coast'},
		{name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=coast'},
		// {name: "Men's Bands", url: 'gallery/wedding-bands/mens?designers=coast'},
	],
	description: [
		'Elegant design and excellent quality. Since 1978, Coast has designed traditional and romantic engagement rings and wedding bands to the highest standards imaginable. Coast continuously introduces beautiful designs that are both graceful and stylish – the hardest of feats to accomplish.',
	],
};

const fana = {
	template: 'designer',
	name: 'Fana',
	titleName: 'Fana Designer',
	displayName: 'Fana',
	// shopLink: 'gallery/engagement-rings?mode=setting&designer=fana',
	links: [
		{name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designer=fana'},
		{name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=fana'},
		{name: "Fashion", url: 'gallery/fine-jewelry?designer=fana'},
	],
	description: [
		'The designers at Fana strive to capture elegance and style in their creations, handcrafting remarkably detailed rings and fine jewelry pieces. Fana takes pride in their extra attention to detail, personal craftsmanship, and the stunning beauty of their designs, offering a wide selection of fine jewelry designed and crafted with the finest diamonds and precious stones.',
	],
};

const furrerjacot = {
	template: 'designer',
	name: 'Furrer Jacot',
	titleName: 'Furrer Jacot',
	displayName: 'Furrer Jacot',
	shopLink: 'gallery/wedding-bands/mens?designers=furrerjacot',
	description: [
		'Since 1858, Swiss manufacturer Furrer Jacot has built a strong market position worldwide by embracing individuality, authenticity, creativity, and a high degree of exclusivity. Furrer Jacot has become a leader in creating diamond rings, carbon fiber rings, and wedding bands, and their designs bear the label of the highest quality for rings with a lifetime warranty.',
	],
};

const gottlieb = {
	template: 'designer',
	name: 'Gottlieb',
	titleName: 'Gottlieb & Sons',
	displayName: 'Gottlieb',
	// shopLink: 'gallery/engagement-rings?mode=setting&designer=gattlieb',
	logoImg: 'gottlieb.png',
	logoStyle: {
		top: '10%',
		height: '80%',
	},
	description: [
		'Gottlieb & Sons has become a trailblazer in the jewelry industry. With the one goal of creating engagement rings and wedding bands that reflect the highest of standards. Gottlieb & Sons engagement rings and wedding bands are fashion forward, upscale, and uniquely distinctive. The brand fits a lifestyle driven, sophisticated customer with a keen eye for luxury.',
	],
};

const henridaussi = {
	template: 'designer',
	name: 'Henri Daussi',
	titleName: 'Henri Daussi',
	displayName: 'Henri Daussi',
	// shopLink: 'gallery/engagement-rings?mode=setting&designer=henridaussi',
	logoImg: 'daussi.svg',
	description: [
		'Henri Daussi is an example of expertise and passion for diamonds passed on over many generations. Cutting the world’s most brilliant diamonds and creating only the finest engagement rings and wedding bands has forever been a Loots family tradition. Henri Daussi is humbled and honored to provide the same excellence in craftsmanship and design set forth by founder, Henri Daussi Loots. We ensure every Henri Daussi engagement ring and wedding band will be a part of your family for years to come.',
	],
};

const jackkelege = {
	template: 'designer',
	name: 'Jack Kelége',
	titleName: 'Jack Kelége',
	displayName: 'Jack Kelége',
	// shopLink: 'gallery/engagement-rings?mode=setting&designer=jackkelege',
	logoImg: 'kelege.svg',
	description: [
		'Headquartered in Los Angeles, Jack Kelége & Co. employs some of the world’s most elite jewelers in the world; all of whom were hand-picked and mentored by Jack Kelége himself. In this day and age, it is extraordinarily rare to find so many astonishing individuals in one place.',
		'Jack Kelége is distinctive in that he is both designer and manufacturer of his own engagement ring and wedding band collections. Jack’s attention to each individual engagement ring and wedding band is what makes his jewelry “heirlooms in the making.” Jack & Co. frequently work for months on a single design to guarantee that their clients receive nothing short of perfection.',
	],
};

const jeffcooper = {
	template: 'designer',
	name: 'Jeff Cooper',
	titleName: 'Jeff Cooper',
	displayName: 'Jeff Cooper',
	// shopLink: 'gallery/engagement-rings?mode=setting&designer=jeffcooper',
	description: [
		'Jeff Cooper engagement rings and wedding bands are crafted one at a time, by hand, and are rigorously inspected by founder Jeff Cooper to ensure that each one reflects its wearer and the memories it symbolizes. Jeff’s designs radiate with clean lines, elegance and a focus on classics that honor his design philosophy of refined simplicity.',
	],
};

const kirkkara = {
	template: 'designer',
	name: 'Kirk Kara',
	titleName: 'Kirk Kara Designer',
	displayName: 'Kirk Kara',
	// shopLink: 'gallery/engagement-rings?mode=setting&designer=kirkkara',
	links: [
		{name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designers=kirkkara'},
		{name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=kirkkara'},
		// {name: "Men's Bands", url: 'gallery/wedding-bands/mens?designers=kirkkara'},
	],
	description: [
		'You’re on this journey to find The One: a diamond engagement ring that will leave you breathless. With every Kirk Kara engagement ring and wedding band, mesmerizing details are designed to evoke love at first sight. Fall madly in love with a Kirk Kara engagement ring or wedding band and see why they are ‘Forever Captivating’. Every piece is crafted delicately by hand so no two are identical. This means the Kirk Kara engagement ring or wedding band that slides onto your finger - is truly one of a kind.',
	],
};

const mastoloni = {
	template: 'designer',
	name: 'Mastoloni',
	titleName: 'Mastoloni Designer',
	displayName: 'Mastoloni',
	shopLink: 'gallery/fine-jewelry?designer=mastoloni',
	description: [
		'Mastoloni cultured pearl jewelry and necklaces have decorated ladies for over a century. Today, at the height of the cultured pearl industry, Mastoloni is proud to be one of the oldest sources in North America. Celebrated for meticulous design and craftsmanship, the name Mastoloni has become synonymous with pure beauty.',
	],
};

const michaelm = {
	template: 'designer',
	name: 'Michael M',
	titleName: 'Michael M Designer',
	displayName: 'Michael M',
	shopLink: 'gallery/engagement-rings?mode=setting&designer=michaelm',
	logoImg: 'michaelm2.svg',
	links: [
		{name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designers=michaelm'},
		{name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=michaelm'},
		// {name: "Men's Bands", url: 'gallery/wedding-bands/mens?designers=michaelm'},
	],
	description: [
		'Founded by the Meksian family and based in Los Angeles, Michael M designs reflect modern elegance and classic beauty. Artfully designed and masterfully handcrafted, every Michael M engagement ring and bridal set is customized to reflect your unique love story.',
	],
};

const novell = {
	template: 'designer',
	name: 'Novell',
	titleName: 'Novell Designer',
	displayName: 'Novell',
	shopLink: 'gallery/engagement-rings?mode=setting&designer=novel',
	links: [
		// {name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designers=novel'},
		{name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=novel'},
		{name: "Men's Bands", url: 'gallery/wedding-bands/mens?designers=novel'},
	],
	description: [
		'Based in New Jersey, Novell Design Studio offers a beautiful, customized range of bridal jewelry designs proudly Made in America for more than 30 years.',
	],
};

const pejay = {
	template: 'designer',
	name: 'PeJay',
	titleName: 'PeJay Creations',
	displayName: 'PeJay',
	// shopLink: 'gallery/engagement-rings?mode=setting&designer=pejay',
	links: [
		// {name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designer=pejay'},
		// {name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=pejay'},
		// {name: "Men's Bands", url: 'gallery/wedding-bands/mens?designers=pejay'},
		{name: "Fashion", url: 'gallery/fine-jewelry?designer=pejay'},
	],
	logoImg: 'pejay.svg',
	description: [
		'Pe Jay Creations, a 60+ year-old family-owned and operated company, prides itself on its designs, quality of production, and, most of all, its attention to detail. Pe Jay offers a full line of women\'s diamond jewelry, including an extensive assortment of fashion jewelry in a variety of textures and colors. In addition, Pe Jay’s offers complete customization to create one-of-a-kind pieces based on your unique needs and desires.',
	],
};

const ses = {
	template: 'designer',
	name: 'SES',
	titleName: 'SES Creations',
	displayName: 'SES',
	// shopLink: 'gallery/engagement-rings?mode=setting&designer=ses',
	links: [
		{name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designer=ses'},
		{name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=ses'},
		{name: "Fashion", url: 'gallery/fine-jewelry?designer=ses'},
	],
	description: [
		'SES Creations is one of the country’s leading designers and manufacturers of bridal, diamond, and precious stone jewelry. Located in New York City, SES Creations takes pride in their wide selection of beautifully-crafted jewelry, including diamond and precious stone rings, earrings, pendants, necklaces, and bracelets, which are available in platinum, 18k and 14k white, yellow or rose gold.',
	],
};

const simong = {
	template: 'designer',
	name: 'Simon G.',
	titleName: 'Simon G Designer',
	displayName: 'Simon G.',
	// shopLink: 'gallery/engagement-rings?mode=setting&designer=simong',
	links: [
		{name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designer=simong'},
		{name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=simong'},
		{name: "Men's Bands", url: 'gallery/wedding-bands/mens?designers=simong'},
		{name: "Fashion", url: 'gallery/fine-jewelry?designer=simong'},
	],
	description: [
		'Elegance, craftsmanship, functionality and affordability are the foundational pillars of the highly desirable and sought after Simon G. engagement rings and wedding bands. Offered in over 7 dozen style combinations, there is a Simon G. for everyone. With over 30 years’ experience, honing finely crafted jewelry making skills, Simon G. has been lauded as one of the most popular and requested names in the industry, specializing in well-known and memorable designs for both men and women.',
		'Unique to his vast and enviable collection of engagement rings and wedding bands is the forward thinking and innovative “double band” concept. Glimpsed on the fingers of even celebrities, this award-winning and intelligent double band configuration combines both wedding and engagement rings with a locking mechanism that keeps the rings together and free from spinning and snagging; making Simon G. engagement rings and wedding bands as comfortable as they are eye-catching.',
		'Some of the more beloved styles include Simon G. TR, LP, NR, LG, MR and Caviar collections. Using only the highest-quality precious metals such as white gold, yellow gold and platinum, in addition to delicately harvested precious carat diamonds available in round, princess, and marquis cuts, Simon G. engagement rings and wedding bands are sure to be more than your next trend; they will become the next family legacy.',
	],
};

const sylvie = {
	template: 'designer',
	name: 'Sylvie',
	titleName: 'Sylvie Collection',
	displayName: 'Sylvie',
	shopLink: 'gallery/engagement-rings?mode=setting&designer=sylvie',
	links: [
		{name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designer=sylvie'},
		{name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=sylvie'},
	],
	logoStyle: {
		maxWidth: '60%',
	},
	description: [
		'The splendor and passion Sylvie sees around the world is reflected in each one of her engagement ring designs. Sylvie truly believes that by building relationships you will find real joy and passion in life. Throughout Sylvie’s bridal and engagement ring collections, you will find a new standard for attainable luxury and the highest example of expertise.',
	],
};

const tacori = {
	template: 'designer',
	name: 'Tacori',
	titleName: 'Tacori Designer',
	displayName: 'Tacori',
	shopLink: 'gallery/engagement-rings?mode=setting&designer=tacori',
	links: [
		{name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designer=tacori'},
		{name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=tacori'},
		{name: "Men's Bands", url: 'gallery/wedding-bands/mens?designers=tacori'},
		{name: "Fashion", url: 'gallery/fine-jewelry?designer=tacorif'},
	],
	description: [
		'Beneath the California sun\'s warm glow, Tacori creates the most intricately crafted artisan jewelry in the world. Each Tacori engagement ring, wedding band, or fashion piece echoes the passion the Tacori family has for creating gorgeous heirlooms to be cherished for generations.  When you wear Tacori, your treasured piece will become a part of the tangible memories that become your legacy.',
	],
};

const trueromance = {
	template: 'designer',
	name: 'True Romance',
	titleName: 'True Romance',
	displayName: 'True Romance',
	shopLink: 'gallery/wedding-bands/mens?designers=trueromanace',
	links: [
		{name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=trueromanace'},
		{name: "Men's Bands", url: 'gallery/wedding-bands/mens?designers=trueromanace'},
	],
	logoImg: 'trueromance.png',
	logoStyle: {
		top: '30%',
		width: '80%',
		height: 'auto',
	},
	description: [
		'True Romance was founded in New York City in 1984 and remains devoted to the vision of creating a line of classic, luxury diamond engagement rings. True Romance’s design team works with great skill to ensure that each piece maximizes the brilliance of the diamonds. Their graceful designs are crafted with clean, classic lines for exceptional beauty and brilliance.',
	],
};

const verragio = {
	template: 'designer',
	name: 'Verragio',
	titleName: 'Verragio Designer',
	displayName: 'Verragio',
	// shopLink: 'gallery/engagement-rings?mode=setting&designer=verragio',
	links: [
		{name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designer=verragio'},
		{name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=verragio'},
		{name: "Men's Bands", url: 'gallery/wedding-bands/mens?designers=verragio'},
		// {name: "Fashion", url: 'gallery/fine-jewelry?designer=verragio'},
	],
	description: [
		'"A beautiful mounting should only enhance the beauty of a diamond in the same way a beautiful dress makes a woman even more beautiful." As said by Barry Verragio, this simple and honest philosophy is reflected in all Verragio engagement rings and wedding bands. With over 20 years experience as a designer of fine jewelry, Verragio has learned the value of craftsmanship and dedication to quality, breathtaking, handcrafted engagement rings and wedding bands.',
	],
};

const amden = {
	template: 'designer',
	name: 'Amden',
	titleName: 'Amden Designer',
	displayName: 'Amden',
	// shopLink: 'gallery/engagement-rings?mode=setting&designer=amden',
	links: [
		// {name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designer=amden'},
		{name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=amden'},
		// {name: "Men's Bands", url: 'gallery/wedding-bands/mens?designers=amden'},
		{name: "Fashion", url: 'gallery/fine-jewelry?designer=amden'},
	],
	logoImg: 'amden.png',
	logoStyle: {
		top: '10%',
		height: '80%',
	},
	description: [
		'Amden Jewelry crafts an all-embracing collection of fashion and bridal rings, pendants, earrings, bracelets and necklaces that are made to be loved forever. Amden, whose reputation rests on professionalism, honors special requests, keeping a detailed eye on every facet of production to ensure the highest quality in their beautiful finished pieces.',
	],
};

const uneek = {
	template: 'designer',
	name: 'Uneek',
	titleName: 'Uneek Designer',
	displayName: 'Uneek',
	// shopLink: 'gallery/engagement-rings?mode=setting&designer=uneek',
	links: [
		{name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designers=uneek'},
		{name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=uneek'},
		{name: "Fashion", url: 'gallery/fine-jewelry?designer=uneek'},
	],
	description: [
		'Uneek\'s unerring eye for the finest quality diamonds and exceptional commitment to quality craftsmanship shine through the most in their award-winning bridal and engagement ring styles. Recognizing that these are the most meaningful pieces of jewelry that a woman will ever wear, and at the same time taking into consideration that today\'s brides are as diverse as they are savvy, Benjamin Javaheri has whipped up a number of bridal collections, each with its own distinctive character and unique styling aspect, to cater to every bride imaginable. Each and every piece in these collections are beautiful works of art, handcrafted in a process that is propelled by technological advancements in fine jewelry making and dictated by centuries-old metalsmithing disciplines, resulting in heirloom-worthy pieces that will last for generations to come.',
		'When you choose Uneek, you are assured of excellence and complete satisfaction with every aspect. Uneek\'s uncompromising dedication to providing only the best quality, the finest workmanship, and true personal service is their promise to Diamonds Direct customers. Also, all Uneek pieces are proudly designed and handcrafted in Los Angeles, CA, so when you choose a Uneek piece, not only are you guaranteed of topnotch quality, you are stamping your support for American artisanship, as well, and contributing to the commitment of keeping the craft alive here in our home.',
	],
};

const odelia = {
	template: 'designer',
	name: 'Odelia',
	titleName: 'Odelia Designer',
	displayName: 'Odelia',
	shopLink: 'gallery/fine-jewelry?designer=odelia',
	logoImg: 'odelia2.png',
	logoStyle: {
		top: '10%',
		height: '80%',
	},
	description: [
		'Over two decades ago in the heart of Manhattan, a family began their journey as purveyors of fine jewelry. With a cemented reputation and driven by their desire to provide a stunning line of affordable diamond jewelry, they set out to become designers and manufacturers, and the Odelia brand was born. Odelia is known for their stunning collection of fashion jewelry that is perfect for any occasion.',
	],
};

// const gabriel = {
// 	template: 'designer',
// 	name: 'Gabriel',
// 	titleName: 'Gabriel Designer',
// 	displayName: 'Gabriel',
// 	// shopLink: 'gallery/engagement-rings?mode=setting&designer=gabrielco',
// 	links: [
// 		{name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designer=gabrielco'},
// 		{name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=gabrielco'},
// 		// {name: "Men's Bands", url: 'gallery/wedding-bands/mens?designers=gabrielco'},
// 		{name: "Fashion", url: 'gallery/fine-jewelry?designer=gabrielco'},
// 	],
// 	description: [
// 		'Gabriel & Co. celebrates life and love through the art & science of fine jewelry. Over the past 30 years, Gabriel & Co. has earned the reputation as being passionate, dependable, and artistic designers, creators and manufacturers. Our extensive line of timeless pieces encompasses classic and fashion-forward design, ultimately bringing together impeccable artistry with enduring technology, perfect for every unforgettable moment.',
// 	],
// };

const classique = {
	template: 'designer',
	name: 'Classique Creations',
	titleName: 'Classique Creations',
	displayName: 'Classique Creations',
	shopLink: 'gallery/engagement-rings?mode=setting&designer=classique',
	links: [
		{name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designer=classique'},
		{name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=classique'},
		{name: "Fashion", url: 'gallery/fine-jewelry?designer=classique'},
	],
	description: [
		'Classique Creations has their finger on the pulse of what\'s trending in the jewelry world. Their unique, fashion-forward bridal designs, including Pinterest-inspired settings and stackable rings, are sure to stand the test of time and be a symbol of your love and devotion for years to come.',
	],
};

const peramore = {
	template: 'designer',
	name: 'Per Amoré',
	titleName: 'Per Amore Designer',
	displayName: 'Per Amoré',
	shopLink: '',
	description: [
		'Over four generations ago, Per Amoré began crafting the finest wedding bands and to this day continues with exceptional hand craftsmanship. With simple, elegant, unique styling using the finest precious metals, Per Amore pays great attention to detail with excellent design execution.  Per Amore passionately creates quality jewelry that remains distinctive and timeless.',
	],
};

const benchmark = {
	template: 'designer',
	name: 'Benchmark',
	titleName: 'Benchmark Designer',
	displayName: 'Benchmark',
	shopLink: 'gallery/wedding-bands/mens?designers=benchmark',
	description: [
		'Benchmark offers stunning, sustainable, high-quality men\'s bands crafted using recycled precious metals of the same high quality as newly mined metals, showing the brand\'s commitment to environmental responsibility. Benchmark is proud to manufacture right here in the United States, and provides a lifetime guarantee for every product.',
	],
};

const dddesigns = {
	template: 'designer',
	name: 'Diamonds Direct Designs',
	titleName: 'Diamonds Direct Designs',
	displayName: 'Diamonds Direct Designs',
	// shopLink: 'gallery/engagement-rings?mode=setting&designer=dddesigns',
	links: [
		{name: "Engagement", url: 'gallery/engagement-rings?mode=setting&designer=dddesigns'},
		{name: "Women's Bands", url: 'gallery/wedding-bands/womens?designers=dddesigns'},
		// {name: "Men's Bands", url: 'gallery/wedding-bands/womens?designers=dddesigns'},
		{name: "Fashion", url: 'gallery/fine-jewelry?designer=dddesigns'},
	],
	description: [
		'At Diamonds Direct, we believe in selection and empowering our customers with the freedom of choice. While our stores feature an expansive line-up of world-renowned fine jewelry designers, we’re also proud to introduce our exclusive collection of engagement rings and wedding bands, Diamonds Direct Designs. From modern simplicity to classic elegance, our master jewelers have created a collection of bridal jewelry that is uniquely ours and is sure to be uniquely yours. It’s the Diamonds Direct Designs promise.',
	],
};


export const ALL = {
	'ajaffe': ajaffe,
	'artcarved': artcarved,
	'cgonshor': cgonshor,
	'christianbauer': christianbauer,
	'christopherdesigns': christopherdesigns,
	'coast': coast,
	'fana': fana,
	'furrerjacot': furrerjacot,
	'gottlieb': gottlieb,
	'henridaussi': henridaussi,
	'jackkelege': jackkelege,
	'jeffcooper': jeffcooper,
	'kirkkara': kirkkara,
	'mastoloni': mastoloni,
	'michaelm': michaelm,
	'novell': novell,
	'pejay': pejay,
	'ses': ses,
	'simong': simong,
	'sylvie': sylvie,
	'tacori': tacori,
	'trueromance': trueromance,
	'verragio': verragio,
	'amden': amden,
	'uneek': uneek,
	'odelia': odelia,
	'classique': classique,
	'peramore': peramore,
	'benchmark': benchmark,
	'dddesigns': dddesigns,
};


// WEBPACK FOOTER //
// ./src/constants/designerpages.jsx